import { useState } from 'react';

export default function ReviewsSection() {
  const [currentReview, setCurrentReview] = useState(0);

  const reviews = [
    {
      name: 'Melanie C.',
      event: 'Wedding Reception',
      location: 'Monserate Winery',
      rating: 5,
      text: 'Everything about this photo booth was beautiful! Guests had so much fun and the pictures turned out great. Plus, Luis was a pleasure to work with! He is very professional and kind, I would 100% book him again!',
      image: 'https://public.readdy.ai/ai/img_res/1d2b173980494cdee9d89bd76140d36e.jpg',
    },
    {
      name: 'Teri H.',
      event: 'Corporate Holiday',
      location: 'Poway, CA',
      rating: 5,
      text: 'Luis was amazing to work with. Communication was excellent, he went above and beyond to make the photo design and process perfect. He arrived well before the event, had everything set up perfectly, and our attendees had an amazing time. The cost, the professionalism, and the outcome were amazing. I highly recommend you book for your next event!',
      image: 'https://readdy.ai/api/search-image?query=professional%20businesswoman%20smiling%20confident%20corporate%20headshot%20simple%20soft%20background%20natural%20lighting%20elegant%20appearance%20friendly%20expression&width=120&height=120&seq=review2&orientation=squarish',
    },
    {
      name: 'Denise N',
      event: 'Birthday Party',
      location: 'Del Mar',
      rating: 5,
      text: 'This was the best decision i made for my daughter\'s party. Not was he professional and responsive but the quality and entertainment we experienced was top notch. The custom project was the cherry on the top. Thank you for everything!',
      image: 'https://readdy.ai/api/search-image?query=friendly%20middle%20aged%20man%20smiling%20casual%20portrait%20simple%20soft%20background%20natural%20lighting%20warm%20expression%20approachable%20demeanor&width=120&height=120&seq=review3&orientation=squarish',
    },
    {
      name: 'Odilia E.',
      event: 'Quinceañera',
      location: 'Vista, CA',
      rating: 5,
      text: 'Luis was Amazing! He was responsive from the beginning asked many questions to arrange set up. Luis was able to engaged my guest. We had his DJ and Photo Booth services. I would highly recommend him I can\'t say enough good things love his personality you won\'t regret it Photo Booth was a big hit!',
      image: 'https://readdy.ai/api/search-image?query=elegant%20hispanic%20woman%20smiling%20warm%20portrait%20simple%20soft%20background%20natural%20lighting%20beautiful%20joyful%20expression%20maternal%20warmth&width=120&height=120&seq=review4&orientation=squarish',
    },
    {
      name: 'Elisa R.',
      event: 'Anniversary Celebration',
      location: 'Coronado',
      rating: 5,
      text: 'Fun Time Photobooth was amazing, from initial contact through the event day! Luis made sure that he was available to answer any questions regarding his services and provided me with options for the services I was requesting. Luis is a true professional and I will continue to recommend him for services!',
      image: 'https://readdy.ai/api/search-image?query=happy%20mature%20couple%20smiling%20together%20portrait%20simple%20soft%20background%20natural%20lighting%20warm%20loving%20expression%20elegant%20appearance&width=120&height=120&seq=review5&orientation=squarish',
    },
    {
      name: 'Lisa F.',
      event: 'Corporate Event',
      location: 'Vista, CA',
      rating: 5,
      text: 'Luis is AMAZING!! We had the 360 Photo Booth for a work party and this was the biggest hit ever!!! He was so cool in engaging everyone to make the best videos! He always kept In Touch with me leading up to the event, was prompt the day of and everything turned out perfect!! I will definitely use him again!! Thank you Luis!!',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20smiling%20confident%20modern%20portrait%20simple%20soft%20background%20natural%20lighting%20stylish%20appearance%20friendly%20expression&width=120&height=120&seq=review6&orientation=squarish',
    },
  ];

  const nextReview = () => {
    setCurrentReview((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentReview((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it – hear from San Diego clients who've experienced the Fun Time difference
          </p>
        </div>

        {/* Featured Review Carousel */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-teal-50 to-teal-100/50 rounded-2xl p-8 md:p-12 relative">
            <div className="flex flex-col items-center text-center">
              
              <div className="flex gap-1 mb-4">
                {[...Array(reviews[currentReview].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-yellow-500"></i>
                ))}
              </div>

              <p className="text-xl md:text-2xl text-gray-800 mb-6 italic leading-relaxed">
                "{reviews[currentReview].text}"
              </p>

              <div className="mb-2">
                <h4 className="text-xl font-bold text-gray-900">
                  {reviews[currentReview].name}
                </h4>
                <p className="text-teal-600 font-medium">
                  {reviews[currentReview].event}
                </p>
                <p className="text-gray-600 text-sm">
                  {reviews[currentReview].location}
                </p>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={prevReview}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
              aria-label="Previous review"
            >
              <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
            </button>
            <button
              onClick={nextReview}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
              aria-label="Next review"
            >
              <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
            </button>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-8">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentReview(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                    index === currentReview
                      ? 'bg-teal-600 w-8'
                      : 'bg-teal-300 hover:bg-teal-400'
                  }`}
                  aria-label={`Go to review ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* All Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-gray-900 truncate">
                    {review.name}
                  </h4>
                  <p className="text-sm text-teal-600 truncate">
                    {review.event}
                  </p>
                </div>
              </div>

              <div className="flex gap-1 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-lg text-yellow-500"></i>
                ))}
              </div>

              <p className="text-gray-600 text-sm leading-relaxed">
                "{review.text}"
              </p>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
            <div className="text-gray-600">Events Completed</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">5.0</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">98%</div>
            <div className="text-gray-600">Client Satisfaction</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
            <div className="text-gray-600">Would Recommend</div>
          </div>
        </div>

        {/* Thumbtack Widget */}
        <div className="mt-16 flex flex-wrap justify-center gap-6">
          <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex flex-col items-center gap-3">
              <img 
                src="https://cdn.thumbtackstatic.com/fe-assets-web/media/logos/thumbtack/wordmark.svg" 
                alt="Thumbtack" 
                className="h-6"
              />
              <a 
                target="_blank" 
                rel="noopener noreferrer"
                href="https://www.thumbtack.com/ca/san-marcos/photo-booth-rentals/fun-time-photobooths/service/434142269401907200"
                className="text-lg font-semibold text-gray-900 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Fun Time Photobooths
              </a>
              <div className="flex items-center gap-2">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <img 
                      key={i}
                      src="https://cdn.thumbtackstatic.com/fe-assets-web/media/pages/profile/standard-widgets/review-widget/orange_star.svg" 
                      alt="star"
                      className="w-5 h-5"
                    />
                  ))}
                </div>
                <span className="text-gray-600 font-medium">39 reviews</span>
              </div>
            </div>
          </div>

          {/* Google Reviews Widget */}
          <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex flex-col items-center gap-3">
              <div className="flex items-center gap-2">
                <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                <span className="text-lg font-semibold text-gray-700">Google</span>
              </div>
              <a 
                target="_blank" 
                rel="noopener noreferrer"
                href="https://www.google.com/search?q=Fun+Time+Photobooths+San+Diego"
                className="text-lg font-semibold text-gray-900 hover:text-teal-600 transition-colors cursor-pointer"
              >
                Fun Time Photobooths
              </a>
              <div className="flex items-center gap-2">
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl text-yellow-400"></i>
                  ))}
                </div>
                <span className="text-gray-600 font-medium">5.0 rating</span>
              </div>
              <p className="text-sm text-gray-500">Based on Google Reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
